const HttpResponseSuccessHandler = response => {
  let realResponse = response
  if (response.data === '') {
    realResponse = Object.assign(response, { data: null })
  }
  return realResponse
}

export default HttpResponseSuccessHandler
